export default __webpack_public_path__ + "static/media/discord.f6946a2e.svg";